module.exports = __webpack_public_path__ + "static/media/beratung_hilfe.1161a9b3.jpg";